var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_1634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4399 24C19.0674 24 24.4399 18.6274 24.4399 12C24.4399 5.37258 19.0674 0 12.4399 0C5.81252 0 0.439941 5.37258 0.439941 12C0.439941 18.6274 5.81252 24 12.4399 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4398 17.7391C15.6095 17.7391 18.179 15.1696 18.179 12C18.179 8.83036 15.6095 6.26086 12.4398 6.26086C9.27018 6.26086 6.70068 8.83036 6.70068 12C6.70068 15.1696 9.27018 17.7391 12.4398 17.7391Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1469 9.80557L14.1315 11.1624L15.726 10.6453L14.7399 12.001L15.7244 13.3577L14.1303 12.8387L13.1442 14.1943L13.1453 12.518L11.5513 11.999L13.1459 11.482L13.1469 9.80557Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7443 15.3913C11.8714 15.3913 10.353 13.8729 10.353 12C10.353 10.127 11.8714 8.60867 13.7443 8.60867C14.3283 8.60867 14.8778 8.75633 15.3576 9.0163C14.605 8.28032 13.5758 7.82605 12.44 7.82605C10.1349 7.82605 8.26611 9.69477 8.26611 11.9999C8.26611 14.3051 10.1349 16.1738 12.44 16.1738C13.5758 16.1738 14.605 15.7196 15.3576 14.9836C14.8778 15.2436 14.3283 15.3913 13.7443 15.3913Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_1634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.439941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.c546116d8fd1a409f0b92cc92a15725f.svg";
export { ForwardRef as ReactComponent };